<script>
	import { splitCamelCaseAndCapitalize } from "src/utils/misc";
	import Lightbox from "../Lightbox/Lightbox.svelte";
	import { imageLightbox } from "src/store/store";

	export let data;
	export let title = "";
	export let lightbox = false;
	export let boxes = []; // [x1, x2, y1, y2]
	export let origShape = []; // [Height, Width]

	let idx = 0;
	let isOpen = false;

	function handleOpenLightBox(i, image) {
		imageLightbox.set([]);
		idx = Number(i);
		isOpen = true;
		imageLightbox.set(image.map((img) => img.imgUrl));
	}
</script>

{#if isOpen && lightbox}
	<Lightbox
		on:click={() => {
			isOpen = false;
		}}
		{idx}
	/>
{/if}
<div class="d-flex flex-column p-3 mr-1" style="height: fit-content;">
	<h4 class="d-flex justify-content-center w-100 my-2">
		<b> {title} </b>
	</h4>

	<div style="height: 80%;">
		<div class="d-flex justify-content-center w-100 my-2">
			<!-- <span>Front</span> -->
			{data.images && data.images.length > 0
				? splitCamelCaseAndCapitalize(data.images[idx].imgSide)
				: ""}
		</div>
		<div
			class="d-flex justify-content-center w-100 my-2 damage-image-container"
		>
			<img
				src="/assets/icon-chevron-left-thin.svg"
				alt="left-arrow"
				class="arrow"
				as="button"
				on:click={() => {
					if (idx > 0) {
						idx--;
					}
				}}
				on:keydown={() => {}}
			/>
			<div
				on:click={() => handleOpenLightBox(idx, data.images)}
				on:keydown={() => {}}
				class="image-wrapper"
			>
				{#if data.images && data.images.length > 0}
					<div class="image-wrapper">
						<img
							src={data.images[idx].imgUrl}
							alt={data.images[idx].imgSide}
							class="damage-image"
							style={data.images[idx].isDamage
								? "border: 2px solid red;"
								: ""}
						/>
						{#if boxes.length > 0 && origShape.length > 0}
							{#each boxes as box}
								<span
									class="bounding-box"
									style="
                                        left: {(box[0] / origShape[1]) * 100}%;
						top: {(box[2] / origShape[0]) * 100}%;
						width: {((box[1] - box[0]) / origShape[1]) * 100}%;
						height: {((box[3] - box[2]) / origShape[0]) * 100}%;"
								/>
							{/each}
						{/if}
						{#if data.images[idx].isDamage}
							<img
								src="/assets/icon-alert-filled-red.svg"
								alt="alert"
								class="alert-icon-thumb"
							/>
						{/if}
					</div>
				{/if}
			</div>
			<img
				src="/assets/icon-chevron-right-thin.svg"
				alt="right-arrow"
				class="arrow"
				as="button"
				on:click={() => {
					if (idx < data.images.length - 1) {
						idx++;
					}
				}}
				on:keydown={() => {}}
			/>
		</div>
		<div
			class="d-flex align-items-end justify-content-center desc-container"
		>
			{#if data.images && data.images.length > 0}
				{#each data.images as image, i}
					<div class="image-thumbnail-wrapper">
						<img
							src={image.imgUrl}
							alt={image.imgSide}
							class="damages-image"
							style={image.isDamage
								? "border: 2px solid red;"
								: ""}
							on:click={() => {
								idx = i;
							}}
							on:keydown={() => {}}
						/>
						{#if image.isDamage}
							<img
								src="/assets/icon-alert-filled-red.svg"
								alt="alert"
								class="alert-icon-thumb"
							/>
						{/if}
					</div>
				{/each}
			{/if}
		</div>
	</div>
</div>

<style>
	.image-thumbnail-wrapper {
		position: relative;
		display: inline-block;
		margin: 0 2px;
		cursor: pointer;
	}

	.alert-icon {
		position: absolute;
		top: -11px;
		right: -7px;
		width: 24px;
		height: 24px;
		background-image: url("/assets/icon-alert-filled-red.svg");
		background-size: cover;
		background-repeat: no-repeat;
	}

	.image-wrapper {
		position: relative;
		display: inline-block;
	}
	.description {
		color: var(--fds-on-surface-variant);
	}

	.review-container {
		border: 1px solid #e8e8e8;
		border-radius: 8px;
	}

	.info-category {
		border-bottom: 1px solid #e8e8e8;
	}

	.damage-image-container {
		height: 90%;
	}

	.damage-image {
		height: 410px;
		width: 100%;
		object-fit: cover;
		display: block;
		max-width: 100%;
	}

	.damages-image {
		height: 40px;
		width: 40px;
		margin: 0 2px;
	}

	img:hover {
		cursor: pointer;
	}
	.arrow {
		width: 30px;
		margin: 0 10px;
	}

	.desc-container {
		margin: 36px 0;
	}
</style>
